import React, { useEffect, useState } from 'react'
import photo from "../../../../Assets/Images/Vector.svg";
import axios from "axios";
import { newBaseUrl } from "../../../../Consts"
import { useNavigate, useParams } from 'react-router-dom';
import { useHome } from '../../../../Context/HomeContext';
import { ToastContainer, toast } from 'react-toastify';
import LoadingOverlay from '../../../LoadingOverlay/LoadingOverlay';

function EditSocialLinkForm() {
    const [selectedStatus, setSelectedStatus] = useState(0);
    const { isSocialLinkById, getSocialLinkById } = useHome()
    const [loading, setLoading] = useState(false);

    const { id } = useParams();

    const navigate = useNavigate();

    useEffect(() => {
        getSocialLinkById(id);
    }, []);

    const handleSaveClick = async () => {
        setLoading(true);
        try {
            // Show loader spinner
            const body = {
                'name': document.getElementById('name').value,
                'url': document.getElementById('link').value,
            };

            const response = await axios.post(`${newBaseUrl}/api/update/socialLink/${id}`, body, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    "Authorization": `Bearer ${localStorage.getItem("token")}`
                },
            });
            toast.success('Social Link updated successfully!', {
                onClose: () => {
                    navigate(`/Home/AllSocialLinks`, { replace: true });
                    setLoading(false);
                },
            });

        } catch (err) {
            // Check if there are validation errors in the response
            if (err.response && err.response.data && err.response.data.errors) {
                // Loop through each error message and display it
                const errors = err.response.data.errors; // Assuming `errors` is an object or array
                for (const key in errors) {
                    if (errors.hasOwnProperty(key)) {
                        errors[key].forEach((message) => {
                            toast.error(message); // Display each error message
                        });
                    }
                }
            } else if (err.response && err.response.data && err.response.data.message) {
                // Display a single error message if available
                toast.error(err.response.data.message);
            } else {
                // Handle other errors
                toast.error("An unexpected error occurred.");
            }
            setLoading(false)
        }
    };


    return (
        <div>
            <ToastContainer autoClose={2000} pauseOnFocusLoss={false} pauseOnHover={false} />
            {(loading || !isSocialLinkById) ? <LoadingOverlay /> :
                <div className="flex justify-start bg-[#fff] rounded-lg py-[50px] px-[50px] h-[100%]">
                    <div style={{ width: '100%' }}>
                        <label
                            className="block text-start text-[16px] font-[400] font-[Cairo] pb-1"
                        >
                            Title <span className="text-red-500">*</span>
                        </label>

                        <input
                            type={'text'}
                            id={'name'}
                            name={'Name'}
                            className="border rounded-lg text-[13px] font-[400] font-[Cairo] mb-2 p-2 w-full h-[40px] border-[#DFEAF2] custom-placeholder-style"
                            placeholder={`Type name here`}
                            disabled='true'
                            defaultValue={isSocialLinkById?.data?.name}
                            style={{
                                paddingBottom: "8px",
                            }}
                        />

                        <label
                            className="block text-start text-[16px] font-[400] font-[Cairo] pb-1"
                        >
                            Link <span className="text-red-500">*</span>
                        </label>

                        <input
                            type={'text'}
                            id={'link'}
                            name={'Link'}
                            className="border rounded-lg text-[13px] font-[400] font-[Cairo] mb-2 p-2 w-full h-[40px] border-[#DFEAF2] custom-placeholder-style"
                            placeholder={`Type link here`}
                            defaultValue={isSocialLinkById?.data?.url}
                            style={{
                                paddingBottom: "8px",
                            }}
                        />
                        <div>
                            <button className="bg-[#0966AE] text-[#fff] rounded-lg py-2 my-3 w-[200px] text-[20px] font-[Cairo]"
                                onClick={handleSaveClick}
                                disabled={loading}
                            >
                                Save
                            </button>
                        </div>
                    </div>
                </div>
            }
        </div>
    )
}

export default EditSocialLinkForm